import RFQForm, { RFQSteps } from '@/components/feature/RFQForm';
import SectionHead from './SectionHead';

export default function QuoteForm() {
  return (
    <section id="quote" className="bg-background-50 border-t border-background-200">
      <div className="max-w-[1200px] mx-auto px-5 md:px-10 py-24 md:py-32">
        <SectionHead index="09" label="Request a Quote" title="TELL US WHAT YOUR LINE NEEDS." intro="Share your requirements. We'll help identify suitable components and quotation options." />
        <RFQForm formId="northline-quote-form" idPrefix="q" className="reveal mt-12 md:mt-16" />
        <RFQSteps className="reveal" />
      </div>
    </section>
  );
}